export const NOTIFICATION_GROUPS = {
  TODAY: 'today',
  EARLIER: 'earlier',
};

export const NOTIFICATION_GROUP_LABELS = {
  today: 'TODAY',
  earlier: 'EARLIER',
};

export const NOTIFICATIONS = [
  {
    id: 'approve-payment',
    dateGroup: NOTIFICATION_GROUPS.TODAY,
    icon: '+',
    iconVariant: 'approve',
    title: 'Approve your payment',
    body: 'Amazon · $42.30 — confirm now',
    time: '2m',
    unread: true,
  },
  {
    id: 'card-payment',
    dateGroup: NOTIFICATION_GROUPS.TODAY,
    icon: 'S',
    iconVariant: 'card',
    title: 'Card payment',
    body: 'Starbucks · $5.40',
    time: '1h',
    unread: false,
  },
  {
    id: 'new-login',
    dateGroup: NOTIFICATION_GROUPS.EARLIER,
    icon: '!',
    iconVariant: 'alert',
    title: 'New login',
    body: 'Telegram Web · Amsterdam',
    time: 'Yesterday',
    unread: false,
  },
  {
    id: 'withdrawal',
    dateGroup: NOTIFICATION_GROUPS.EARLIER,
    icon: '↑',
    iconVariant: 'card',
    title: 'Withdrawal sent',
    body: '$196.00 to your USDT wallet',
    time: 'Yesterday',
    unread: false,
  },
  {
    id: 'money-moved',
    dateGroup: NOTIFICATION_GROUPS.EARLIER,
    icon: '↕',
    iconVariant: 'alert',
    title: 'Money moved',
    body: '$200.00 Main → Travel',
    time: '2d',
    unread: false,
  },
];
